import { render, staticRenderFns } from "./ZoneDetails.vue?vue&type=template&id=27b0d33c"
import script from "./ZoneDetails.vue?vue&type=script&lang=js"
export * from "./ZoneDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports